import { EventPermissions } from "@clockwise/schema";
import { noop } from "lodash";
import React from "react";
import { EventCardExpanded } from "../../../../../event-card/EventCardExpanded";
import {
  DEFAULT_CONTEXT_VALUES,
  EventCardContextProvider,
} from "../../../../../event-card/hooks/EventCardContext";
import { ECAgenda } from "../../../../../event-card/molecules/ECAgenda";
import { ECAttendeeWrapper } from "../../../../../event-card/molecules/ECAttendeesV2/ECAttendeeWrapper";
import { ECFlexibility } from "../../../../../event-card/molecules/ECFlexibility";
import { ECFooter } from "../../../../../event-card/molecules/ECFooter";
import { Time } from "../../../../../event-card/molecules/ECTime";
import { ECTitle } from "../../../../../event-card/molecules/ECTitle";
import { EventCardMode } from "../../../../../event-card/types";
import {
  getDeleteEventCopy,
  getSubmitButtonCopy,
} from "../../../../../event-card/utils/getSubmitButtonCopy";

type DiffEventCardLoadingProps = {
  onClose: () => void;
};

export const DiffEventCardLoading = ({ onClose }: DiffEventCardLoadingProps) => {
  return (
    <EventCardContextProvider initValue={DEFAULT_CONTEXT_VALUES}>
      <EventCardExpanded
        loading={true}
        alsoSendUpdates={false}
        onClose={onClose}
        mode={EventCardMode.default}
        footer={
          <ECFooter
            disabled={true}
            onSubmit={noop}
            permissions={EventPermissions.NONE}
            submissionCopy={getSubmitButtonCopy(true)}
            deletionCopy={getDeleteEventCopy(false)}
          />
        }
      >
        <ECTitle readOnly={true} eventName={""} onEventNameChange={noop} loading={true} />
        <ECFlexibility
          flexibilityDescription={""}
          flexibilityStatus={"Default"}
          isFlexible={false}
          onFlexibilityChange={noop}
          onPauseChange={noop}
          readOnly={true}
          loading={true}
        />
        <ECAttendeeWrapper nonEditableAttendeeIds={new Set()} readOnly={true} loading={true} />
        <Time readOnly={true} loading={true} />
        <ECAgenda loading={true} readOnly={true} agenda={""} onChangeAgenda={noop} />
      </EventCardExpanded>
    </EventCardContextProvider>
  );
};
